<template>
  <div class="content-message">
    <div class="top">
      <div class="title">指派规则</div>
      <div class="top-button" @click="goAdd(1)">+ 新建</div>
    </div>
    <div class="search">
      <el-form class="search-from" ref="form" :model="searchForm" label-width="85px">
        <el-form-item label="规则名称">
          <el-input style="width: 160px;" v-model="searchForm.ruleName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="规则ID">
          <el-input style="width: 160px;" v-model="searchForm.id" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" size="small"  :clearable="true">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="search-button">
          <div class="button-refer" @click="search">查询</div>
        </div>
      </el-form>
    </div>
    <div class="table">
      <div class="table-list">
        <el-table
          :data="list.list"
          style="width: 100%"
          :header-cell-style="bgColor"
          v-loading="loading">
          <el-table-column
            label="规则ID"
            width="80"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="规则名称"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.ruleName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="包含省份"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.province }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="不包含省份"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.notProvince }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="包含城市"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.city }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="不包含城市"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.notCity }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="市场价"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span v-if="row.minMarketPriceBig ==null && row.maxMarketPriceBig == null">不限</span>
              <span v-else>{{ row.minMarketPriceBig}}元-{{row.maxMarketPriceBig }}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="包含影院"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.cinemaName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="不包含影院"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.notCinemaName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="包含影厅"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.hallName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="不包含影厅"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.notHallName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="启用状态"
            align="center"
            width="220">
            <template slot-scope="{row}">
              <el-switch
                v-model="row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              @change="update($event,row)" v-if="row.systemCreate == 0">
              </el-switch>
              <span v-if="row.status == 1" style="color: #3D9EFC;">启用</span>
              <span v-else style="color: #FF4F76;">关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            width="220">
            <template slot-scope="{row}"  v-if="row.systemCreate == 0">
              <span class="table-text" @click="goAdd(2,row)">修改规则</span>
              <span class="table-delete" @click="deleteRules(row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="list.total > 0"
          background
          class="align-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="list.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total">
        </el-pagination>
      </div>
    </div>
<!--    提示-->
    <el-dialog
      title="确定删除"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
     <div class="center-hint">
       <div class="center-hint-title">确定删除？</div>
       <div class="center-hint-text">删除后不可恢复，请谨慎操作！</div>
       <div class="button">
         <div class="button-cancel" @click="dialogVisible = false">取消</div>
         <div class="button-confirm" @click="confirm">确定</div>
       </div>
     </div>
    </el-dialog>
  </div>
</template>

<script>
import { saasOrder} from "../../../../javaApi/saasOrder";
const saasM = new saasOrder()
export default {
name: "index",
  data(){
    return{
      searchForm:{
        ruleName:'',
        status:'',
        id:'',
        pageNo:1,
        pageSize:10
      },
      list:[],
      options:[{
        label:'开启',
        value:'1'
      },
        {
          label:'关闭',
          value:'0'
        }],
      // 表头颜色
      bgColor:{
        background: '#FCFAF8'
      },
      dialogVisible:false,
      currentPage:1,
      id:'',
      loading:true
    }
  },
  mounted() {
  this.getList()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose(){
      this.dialogVisible = false
    },
    // 获取列表
    getList(){
      let params = this.searchForm
      saasM.getAssignRules(params).then(res=>{
        if(res.data.code == 200){
          this.list = res.data.data
          this.loading = false
          console.log(this.list)
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 删除规则
    deleteRules(row){
      this.dialogVisible = true
      this.id = row.id
    },
    confirm(){
      let params = {
        id:this.id
      }
      saasM.deleteAssignRules(params).then(res=>{
        if(res.data.code == 200){
          this.$Message.success('删除成功')
          this.getList()
          this.dialogVisible = false
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 跳转到添加规则
    goAdd(index,row){
      console.log(row)
      if(index == 2){
        // 因为修改要把字符串转成数组格式的才能显示
        if(row.notProvince){
          row.notProvince = row.notProvince.split(',')
        }
        if(row.cinemaName){
          row.cinemaName = row.cinemaName.split(',')
        }
        if(row.notCinemaName){
          row.notCinemaName = row.notCinemaName.split(',')
        }
        if(row.province){
          row.province = row.province.split(',')
        }
        if(row.city){
          row.city = row.city.split(',')
        }
        if(row.notCity){
          row.notCity = row.notCity.split(',')
        }
        if(row.movie){
          row.movie = row.movie.split(',')
        }
        if(row.notMovie){
          row.notMovie = row.notMovie.split(',')
        }
        if(row.hallName){
          row.hallName = row.hallName.split(',')
        }
        if(row.notHallName){
          row.notHallName = row.notHallName.split(',')
        }
        if(row.fakeCinemaName){
          row.fakeCinemaName = row.fakeCinemaName.split(',')
        }
        if(row.startDateBegin){
          row.startDateBegin = row.startDateBeginStr
        }
        if(row.startDateEnd){
          row.startDateEnd = row.startDateEndStr
        }
        if(row.notStartDateBegin){
          row.notStartDateBegin = row.notStartDateBeginStr
        }
        if(row.notStartDateEnd){
          row.notStartDateEnd = row.notStartDateEndStr
        }
      }
      this.$router.push({
        path:'/pc/SaasJoin/assignRules/addRules',
        query:{
          type:index,
          row:row
        }
      })
    },
    // 查询
    search(){
      this.loading = true
      this.getList()
    },
    update(e,row){
      console.log(e)
      let param = {
        id:row.id,
        status:e
      }
      saasM.updateStatus(param).then(res=>{
        if(res.data.code == 200){
          this.$Message.success('修改成功')
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
        this.getList()

      })
    }
  }
}
</script>

<style scoped lang="less">
.content-message{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
    }
    .top-button{
      width: 88px;
      height: 36px;
      background: #FF8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 36px;
      cursor: pointer;
    }
  }
  .search{
    margin-top: 20px;
    display: flex;
    align-items: center;
    .search-from{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .search-button{
      display: flex;
      align-items: center;
      margin-left: 20px;
      .button-refer{
        width: 76px;
        height: 32px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 32px;
        cursor: pointer;
      }
      .button-export{
        width: 76px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.center-hint{
  text-align: center;
  .center-hint-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 22px;
  }
  .center-hint-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FF4F76;
    line-height: 20px;
    margin-top: 10px;
  }
  .button{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 43px;
    .button-cancel{
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 32px;
      margin:0 10px;
      cursor: pointer;
    }
    .button-confirm{
      width: 104px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
      line-height: 32px;
      margin: 0 10px;
      cursor: pointer;
    }
  }
}
.table-text{
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3D9EFC;
  line-height: 20px;
  cursor: pointer;
}
.table-delete{
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 20px;
  cursor: pointer;
}
.table{
  margin-top: 20px;
}
/deep/.el-form-item{
  margin-bottom: 0;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
/deep/.el-input__inner:focus{
  border-color: #FF8622!important;
}
/deep/.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color: #FF8622!important;
}
/deep/.el-date-table td.today{
  background: #FF8622;
}
/deep/.el-input__inner:hover{
  background: #FCF8F5;
  border-color: #FF8622!important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #FF8622!important;
}
.align-right{
  text-align: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/assignRules/index.vue